import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as $ from 'jquery';

if (environment.production) {
  enableProdMode();
}

document.getElementsByTagName('html')[0].className = 'flexbox';
platformBrowserDynamic().bootstrapModule(AppModule);

$('body').on('focus', 'input[type="text"]', function(ev) {
  const input = ev.currentTarget;

  if ((window as any)['_trackAnalytics']) {
    (window as any)['_trackAnalytics']({
      site_events: { input_click: true },
      input_name: (input as any)['placeholder'] || (input as any)['name']
    });
  }
});
